import { ArrowLeft, ghost } from "lucide-react"; // Importamos icono para navegación

export default function PageNotFound() {
    return (
        <div className="min-h-screen bg-[#050f08] flex items-center justify-center px-6 relative overflow-hidden selection:bg-[#c9a84c] selection:text-white">

            {/* Elementos decorativos de fondo */}
            <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-[#c9a84c]/5 blur-[120px] rounded-full"></div>
            <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-green-900/10 blur-[120px] rounded-full"></div>

            <div className="relative z-10 flex flex-col items-center max-w-lg text-center">

                {/* Indicador de Error Sutil */}
                <div className="mb-8">
                    <span className="text-[#c9a84c] text-[12px] font-black tracking-[0.6em] uppercase italic opacity-80">
                        Error de Navegación
                    </span>
                </div>

                {/* Código de Error con Tipografía Impactante */}
                <h1 className="text-white text-8xl md:text-9xl font-black tracking-tighter leading-none mb-4 opacity-90">
                    404
                </h1>

                {/* Mensaje Formal */}
                <div className="h-px w-16 bg-[#c9a84c]/40 mb-8 mx-auto"></div>

                <h2 className="text-white text-2xl md:text-3xl font-black uppercase tracking-tight mb-6">
                    Página no encontrada
                </h2>

                <p className="text-white/40 text-sm md:text-base font-medium leading-relaxed italic mb-12 max-w-sm">
                    El recurso al que intenta acceder no está disponible o ha sido movido de forma permanente.
                </p>

                {/* Botón de Retorno Minimalista */}
                <a
                    href="/"
                    className="group flex items-center gap-3 bg-transparent border border-white/10 hover:border-[#c9a84c] px-10 py-4 rounded-full transition-all duration-500 no-underline"
                    title="Volver al inicio"
                >
                    <ArrowLeft size={16} className="text-[#c9a84c] group-hover:-translate-x-1 transition-transform" />
                    <span className="text-white/60 group-hover:text-white text-[11px] font-black uppercase tracking-[0.3em]">
                        Regresar al inicio
                    </span>
                </a>

                {/* Marca de agua al pie */}
                <div className="mt-20">
                    <p className="text-white/5 text-[9px] font-black uppercase tracking-[0.5em] select-none">
                        Integral Agropecuaria S.R.L
                    </p>
                </div>
            </div>
        </div>
    );
}